import * as React from "react";
import ActionDropdown from "views/components/common/ActionDropdown";
import { IconButton } from "components/common";
const WidgetActionDropdown = ({ children }) => {
  const widgetActionDropdownCaret = /* @__PURE__ */ React.createElement(IconButton, { name: "keyboard_arrow_down", title: "Open actions dropdown" });
  return /* @__PURE__ */ React.createElement(ActionDropdown, { element: widgetActionDropdownCaret }, children);
};
export default WidgetActionDropdown;
